"use client"

import React from "react"
import "./css/header.css"

export default function Header() {
  const [scrolled, setScrolled] = React.useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false)
  const [fixedHeaderHeight, setFixedHeaderHeight] = React.useState(0)

  const mainNavRef = React.useRef(null)
  const separatorLineRef = React.useRef(null)

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    const calculateFixedHeaderHeight = () => {
      const navHeight = mainNavRef.current ? mainNavRef.current.offsetHeight : 0
      const separatorHeight = separatorLineRef.current ? separatorLineRef.current.offsetHeight : 0
      setFixedHeaderHeight(navHeight + separatorHeight)
    }

    window.addEventListener("scroll", handleScroll)
    window.addEventListener("resize", calculateFixedHeaderHeight) // Recalcular en resize
    calculateFixedHeaderHeight() // Calcular al montar

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("resize", calculateFixedHeaderHeight)
    }
  }, [])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <header className="header-container">
      {/* Top Bar - Se oculta al hacer scroll */}
      

      {/* Green/Orange Separator Line - Always visible, but fixed with main nav */}
      <div ref={separatorLineRef} className={`header-separator-line ${scrolled ? "fixed-on-scroll-line" : ""}`}></div>

      {/* Placeholder for fixed elements to prevent content jump */}
      {scrolled && <div className="fixed-elements-placeholder" style={{ height: `${fixedHeaderHeight}px` }}></div>}

      {/* Main Navigation Bar - Permanece fijo */}
      <nav ref={mainNavRef} className={`main-nav ${scrolled ? "fixed-on-scroll-nav" : ""}`}>
        <div className="nav-container">
          <a href="#" className="logo-link">
            <img src="/img/logo.png" alt="Grantec" className="logo-img" />
          </a>

          {/* Desktop Navigation */}
          <div className="nav-links-desktop">
            <ul>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li>
            <li>
            </li><li>
            </li><li>
            </li><li>
            </li>
            
              <li>
                <a href="#Inicio" className="nav-link">
                  INICIO
                </a>
              </li>
              <li>
                <a href="#Nosotros" className="nav-link">
                  NOSOTROS
                </a>
              </li> 
              <li>
                <a href="#Porta" className="nav-link">
                  CATÁLOGO
                </a>
              </li> 
              <li>
                <a href="#Footer" className="nav-link">
                  CONTACTO
                </a>
              </li>
            </ul>
          </div>

          {/* Right-side Icons */}
          <div className="action-icons">
            
            
            

            {/* Mobile Menu Trigger */}
            <button className="mobile-menu-button" onClick={toggleMobileMenu} aria-label="Toggle navigation menu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" x2="20" y1="12" y2="12" />
                <line x1="4" x2="20" y1="6" y2="6" />
                <line x1="4" x2="20" y1="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Content */}
      <div className={`mobile-menu-content ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="mobile-menu-header">
          <a href="#" className="logo-link" onClick={toggleMobileMenu}>
            <img src="/img/logo.png" alt="Grantec Logo" className="logo-img" />
          </a>
          <button className="close-button" onClick={toggleMobileMenu} aria-label="Close navigation menu">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        <div className="mobile-nav-links">
          <a href="#Inicio" className="mobile-nav-link active" onClick={toggleMobileMenu}>
            INICIO
          </a>
          <a href="#Nosotros" className="mobile-nav-link" onClick={toggleMobileMenu}>
            NOSOTROS
          </a> 
          <a href="#Porta" className="mobile-nav-link" onClick={toggleMobileMenu}>
            DESCARGAS
          </a> 
          <a href="#Footer" className="mobile-nav-link" onClick={toggleMobileMenu}>
            CONTACTO
          </a>
        </div>
      </div>
    </header>
  )
}
